import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root is missing from index.html');
}

// Dev-only backdrop preview and picker (see tsugi/Preview.tsx, tsugi/Picker.tsx);
// never part of a build.
const params = new URLSearchParams(window.location.search);
const preview = import.meta.env.DEV ? params.get('preview') : null;
const pick = import.meta.env.DEV ? params.get('pick') : null;

if (pick !== null) {
  void import('./tsugi/Picker').then(({ Picker }) =>
    createRoot(container).render(
      <StrictMode>
        <Picker slug={pick} />
      </StrictMode>,
    ),
  );
} else if (preview) {
  void import('./tsugi/Preview').then(({ Preview }) =>
    createRoot(container).render(
      <StrictMode>
        <Preview slug={preview} />
      </StrictMode>,
    ),
  );
} else {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
